import { render, staticRenderFns } from "./NextTransition.vue?vue&type=template&id=70ff844e&scoped=true&"
import script from "./NextTransition.vue?vue&type=script&lang=js&"
export * from "./NextTransition.vue?vue&type=script&lang=js&"
import style0 from "./NextTransition.vue?vue&type=style&index=0&id=70ff844e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff844e",
  null
  
)

export default component.exports